/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { getSSRAttach, getAttach } from '../utils/dom.mjs';
import { computed, ref, onMounted, watch } from 'vue';
import { i as isFunction_1 } from '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../utils/easing.mjs';
import '../_chunks/dep-4efc69ee.mjs';

var useTeleport = function useTeleport(attach, triggerNode) {
  var to = isFunction_1(attach) ? computed(attach) : ref(attach);
  var innerTriggerNode = isFunction_1(triggerNode) ? computed(triggerNode) : ref(triggerNode);
  var element = ref();
  var getElement = function getElement() {
    element.value = getSSRAttach() || getAttach(to.value, innerTriggerNode.value);
  };
  onMounted(function () {
    return getElement();
  });
  watch([to, innerTriggerNode], function () {
    return getElement();
  });
  return element;
};

export { useTeleport as default };
//# sourceMappingURL=useTeleport.mjs.map
